import { render } from "./CaptionWhite.vue?vue&type=template&id=7b3dba3e&scoped=true"
import script from "./CaptionWhite.vue?vue&type=script&lang=js"
export * from "./CaptionWhite.vue?vue&type=script&lang=js"

import "./CaptionWhite.vue?vue&type=style&index=0&id=7b3dba3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b3dba3e"]])

export default __exports__